import React from 'react';
import { CircularProgress, makeStyles, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { PropTypes } from 'prop-types';
const styles = makeStyles((prop) => ({
    autoCompleteRoot: {
        width: '100%',
        paddingRight: '13px',
        display: 'flex'
    },
    popupIndicator: {
        display: 'none'
    },
    endAdornment: {
        display: 'none'
    },
    input: {
        borderBottom: 'solid 0.5px #bbbbbb',
        fontSize: '16px',
        fontWeight: '500',
        padding: '0 !important',
        width: '100% !important',
        borderRadius: 0
    },
    inputRoot: {
        padding: '0 !important'
    },
    option: {
        color: '#767676',
        textAlign: 'left',
        direction: 'ltr',
        fontSize: '14px'
    },
    popper: {
        color: '#767676',
        textAlign: 'left',
        direction: 'ltr',
        fontSize: '14px',
        display: prop?.inputValue ? 'block' : 'block'
    },
    textFieldRoot: {
        display: 'block'
    },
    loadingIcon: {
        position: 'absolute',
        right: '0',
        top: '0'
    }
}));
const DrugSelect = ({
    options,
    inputValue,
    value = '',
    handleDrugChange,
    handleDrugSelected,
    isLoading
}) => {
    const classes = styles({ inputValue });
    return (
        <Autocomplete
            classes={{
                root: classes.autoCompleteRoot,
                inputRoot: classes.inputRoot,
                input: classes.input,
                option: classes.option,
                popupIndicator: classes.popupIndicator,
                endAdornment: classes.endAdornment,
                tag: classes.tag,
                popper: classes.popper
            }}
            id="drugName"
            freeSolo
            options={options || []}
            getOptionLabel={(option) => option?.name || ''}
            filterOptions={(options) => options}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
                handleDrugChange(newInputValue);
            }}
            value={value}
            onChange={(event, newValue) => {
                handleDrugSelected(newValue);
            }}
            renderInput={(params) => (
                <TextField
                    classes={{ root: classes.textFieldRoot }}
                    {...params}
                    label={''}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {isLoading ? (
                                    <CircularProgress
                                        className={classes.loadingIcon}
                                        color="inherit"
                                        size={15}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
            loading={isLoading}
        />
    );
};
DrugSelect.propTypes = {
    options: PropTypes.array,
    handleDrugChange: PropTypes.func,
    handleDrugSelected: PropTypes.func,
    inputValue: PropTypes.string,
    value: PropTypes.object,
    isLoading: PropTypes.bool
};
export default DrugSelect;
